import { render, staticRenderFns } from "./concierge-account.html?vue&type=template&id=264c97f1&scoped=true&"
import script from "./concierge-account.js?vue&type=script&lang=js&"
export * from "./concierge-account.js?vue&type=script&lang=js&"
import style0 from "./concierge-account.scss?vue&type=style&index=0&id=264c97f1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264c97f1",
  null
  
)

export default component.exports